import React from 'react'
import { URL_SRV_ARIZTIA } from '../../router/Url';

export const GetDataTAbleFaena = ({PLANTA, AREA}) => {
    // console.log(bulkData);
    return new Promise(async (resolve, reject) => {
        let query = await fetch(URL_SRV_ARIZTIA+'gettablaindicadores',{
          method: 'POST',
          headers: {
            'authorization': "paico2021",
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            PLANTA, AREA
          })
        })
        let responsito = await query.json();
        // console.log(responsito.body)
        if(responsito.success){
          resolve(responsito.body.TABLA)
        }else{
          resolve(null)
        }
    })
}
